import { PartialBrief } from '../../../../Types/Brief'
import { BriefAttributes } from '../../../../Types/generated-types'
import { dateToMachineString } from '../../../../Views/FormSteps/DateTime/Utilities/dateStrings'

const getSubmissionParams = (brief: PartialBrief): BriefAttributes => {
  const {
    budget,
    capacities,
    lat,
    lon,
    location,
    guest,
    fromDate,
    toDate,
    userId,
    ...optionalAttrs
  } = brief

  if (
    budget !== undefined &&
    capacities !== undefined &&
    lat !== undefined &&
    lon !== undefined &&
    location !== undefined &&
    fromDate != undefined &&
    toDate != undefined &&
    userId !== undefined
  ) {
    const zonelessStartDate = dateToMachineString(new Date(fromDate))
    const zonelessEndDate = dateToMachineString(new Date(toDate))

    return {
      ...optionalAttrs,
      budget,
      capacities,
      lat: lat.toString(),
      lon: lon.toString(),
      flexibleDatesNote: optionalAttrs.flexibleDates ? optionalAttrs.flexibleDatesNote : undefined,
      location,
      fromDate: zonelessStartDate,
      toDate: zonelessEndDate,
      userId,
    }
  }

  throw new Error('Brief missing required attrs for submission')
}

export default getSubmissionParams
